import {
  PDP_DEATAIL,
  PDP_VIEW,
  PDP,
  NAVIGATION,
  CROSS_SELL,
  ADD_INSTALL,
  PURCHASE_DESIGN,
  STORE_NEAR,
  FIND_PRO,
  ADD_TO_CART,
  BASED_ON_LOCATION,
  PRODUCT_DECS,
  PRODUCT_TYPE,
  PRODUCT_INSATLL,
} from "@/components/ProductDetail/v3/ProductDetailView/analytics/constant"
import { getPureText } from "@/utils/helper"

export const addAnalyticsForViewNowClick = productInfo => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${PDP_DEATAIL}:view in your space`,
    eventName: `${PDP}:${PDP_DEATAIL}:view in your space`,
    eventType: NAVIGATION,
    internalLinkName: "view in your space",
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${PDP_VIEW}`,
    internalLinkZoneName: `${PDP}:${PDP_DEATAIL}`,
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForCloseClick = productInfo => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${PDP_DEATAIL}:modal:${PDP_VIEW}:close`,
    eventName: `${PDP}:${PDP_DEATAIL}:modal:${PDP_VIEW}:close`,
    eventType: NAVIGATION,
    internalLinkName: "close",
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:close`,
    internalLinkZoneName: `${PDP}:${PDP_DEATAIL}:modal:${PDP_VIEW}`,
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForChangeZipCode = (
  titleName = "",
  productInfo = {},
  zipval = 0
) => {
  const title = titleName.toLowerCase()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${CROSS_SELL}:${title}`,
    eventName: `${PDP}:${CROSS_SELL}:${title}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventType: NAVIGATION,
    internalLinkName: title,
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${zipval}`,
    internalLinkZoneName: `${PDP}:${CROSS_SELL}:${BASED_ON_LOCATION}`,
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForUpdate = (
  titleName = "",
  productInfo = {},
  zipval = 0,
  showcard = true
) => {
  const title = titleName.toLowerCase()
  const eventStatusItem = showcard ? "success" : "failure"
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${CROSS_SELL}:${title} zip code`,
    eventName: `${PDP}:${CROSS_SELL}:${title} zip code`,
    eventMsg: "n/a",
    eventStatus: `${eventStatusItem}`,
    eventType: NAVIGATION,
    internalLinkName: title,
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${zipval}`,
    internalLinkZoneName: `${PDP}:${CROSS_SELL}:${BASED_ON_LOCATION}`,
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForBuymore = (
  titleName = "",
  url,
  productInfo = {}
) => {
  const title = titleName.toLowerCase()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${CROSS_SELL}:${title}`,
    eventName: `${PDP}:${CROSS_SELL}:${title}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventType: NAVIGATION,
    internalLinkName: title,
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${ADD_INSTALL}`,
    internalLinkZoneName: `${PDP}:${CROSS_SELL}:${ADD_INSTALL}`,
    internalLinkURL: url ? url : "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForAddService = (
  titleName = "",
  productitem = {},
  serviceName = "",
  servicePrice = 0,
  productServices = ""
) => {
  const title = titleName.toLowerCase()
  const service = getPureText(serviceName).toLowerCase()
  const { productName = "", quantity = 1, productBrand = "" } = productitem
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${CROSS_SELL}:${ADD_INSTALL}:${ADD_TO_CART}`,
    eventName: `${PDP}:${CROSS_SELL}:${ADD_INSTALL}:${ADD_TO_CART}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventType: NAVIGATION,
    internalLinkName: title,
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${service}`,
    internalLinkZoneName: `${PDP}:${CROSS_SELL}:${ADD_INSTALL}`,
    internalLinkURL: "n/a",
  }
  const productInfo = {
    defaultImageName: "n/a",
    description: PRODUCT_DECS,
    frequency: "n/a",
    globalPromotionPrice: servicePrice,
    isRecommended: "n/a",
    isSendNow: "n/a",
    isSubscription: "n/a",
    numberOfReviews: "n/a",
    pdpType: PRODUCT_TYPE,
    priceState: "regular price",
    productBasePrice: servicePrice,
    productBrand: productBrand,
    productCategory: PRODUCT_INSATLL,
    productCollectionsName: PRODUCT_INSATLL,
    productColor: "n/a",
    productCouponCode: "n/a",
    productCoupondiscount: "n/a",
    productFindingMethod: "n/a",
    productID: "K-" + productServices,
    productName: productName,
    productPartnerBuyNow: "n/a",
    productRoom: PRODUCT_INSATLL,
    productSalePrice: servicePrice,
    productSaleable: "true",
    productStatus: "in stock",
    productSuperSku: "false",
    productTileName: "installation services",
    quantity: quantity,
    ratings: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForBathroomDesign = (
  titleName = "",
  url,
  productInfo = {}
) => {
  const title = titleName.toLowerCase()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${CROSS_SELL}:${title}`,
    eventName: `${PDP}:${CROSS_SELL}:${title}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventType: NAVIGATION,
    internalLinkName: title,
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${PURCHASE_DESIGN}`,
    internalLinkZoneName: `${PDP}:${CROSS_SELL}:${PURCHASE_DESIGN}`,
    internalLinkURL: url,
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForStoreNearYou = (
  titleName = "",
  url,
  productInfo = {}
) => {
  const title = titleName.toLowerCase()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${CROSS_SELL}:${title}`,
    eventName: `${PDP}:${CROSS_SELL}:${title}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventType: NAVIGATION,
    internalLinkName: title,
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${STORE_NEAR}`,
    internalLinkZoneName: `${PDP}:${CROSS_SELL}:${STORE_NEAR}`,
    internalLinkURL: url,
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForGetProfessionalClick = (
  titleName = "",
  url,
  productInfo = {}
) => {
  const title = titleName.toLowerCase()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${CROSS_SELL}:${title}`,
    eventName: `${PDP}:${CROSS_SELL}:${title}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventType: NAVIGATION,
    internalLinkName: title,
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${FIND_PRO}`,
    internalLinkZoneName: `${PDP}:${CROSS_SELL}:${FIND_PRO}`,
    internalLinkURL: url,
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsPdpAffirmText = (
  affirmTitle = "",
  affirmClickText = "",
  productInfo = {},
  isBundleProduct = ""
) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:product details:${affirmTitle}:${affirmClickText}`,
    eventName: `${PDP}:product details:${affirmTitle}:${affirmClickText}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventType: NAVIGATION,
    internalLinkName: affirmClickText,
    internalLinkPosition: `${PDP}${isBundleProduct ? ":bundle" : ""}`,
    internalLinkType: `${PDP}:${NAVIGATION}`,
    internalLinkZoneName: `${PDP}:product details:${affirmTitle}:${affirmClickText}`,
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

const pushAnalyticsObjToDataLayer = (eventInfo = {}, productInfo = {}) => {
  const page = window.pageObj || {}
  const event = "cmp:click"
  window.adobeDataLayer.push({
    event,
    eventInfo,
    page,
    productInfo,
  })
}

export const addAnalyticsForRightToKnowInfoButtonClick = (productInfo = {}) => {
  const eventInfo = {
    eventAction: "pdp:product details:right to know information",
    eventName: "pdp:product details:right to know information",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "right to know information",
    internalLinkPosition: "pdp",
    internalLinkType: "pdp:navigation",
    internalLinkZoneName: "pdp:product details",
    internalLinkURL: "n/a",
    clickInternalLinks: "false",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

// analytic for cmp:show
export const addPageLoadAnalytics = data => {
  const {
    pageLoadAnalyticsTimer,
    getProcessedProductInfo,
    productLocalCategory,
    imagesData,
    isShowAnalyticsEventLoaded,
    getUserAnalyticsObject,
    setProductInfo,
    productImagesWithUrls,
  } = data
  const asset = imagesData[0] || []
  const assetType = asset?.type === "video" ? "videoId" : "imageId" || ""
  const assetId = asset?.type === "video" ? asset?.url : asset?.assetId || ""
  const resourceType =
    productImagesWithUrls[0]?.toString()?.split("|")?.[2] || ""
  const { productAnalyticsData = {}, productInfo = {} } =
    getProcessedProductInfo(true)

  if (window.datalayerTopLoaded && window.adobeDataLayer.length > 0) {
    clearInterval(pageLoadAnalyticsTimer)
    const page = window.pageObj || {}
    const category = window.pageObj?.category || {}
    const pageType = window.pageObj?.category?.pageType || ""
    const siteName = productAnalyticsData.brandName
    const pageInfo = window.pageObj?.pageInfo || {}
    category["subCategory1"] = pageType + ":" + productAnalyticsData.category
    category["productLocalCategory"] = productLocalCategory
    category["subCategory2"] =
      pageType +
      ":" +
      productAnalyticsData.category +
      ":" +
      productAnalyticsData.customerFacingSKU
    category["subCategoryID"] = productAnalyticsData.customerFacingSKU
    category["room"] = productInfo?.productRoom || ""
    if (window.needPdpdata) {
      const url = new URL(window.location.href)
      const pdpSkuUrl = url.searchParams.get("skuId")
      const { productSubCatergory = "", skuID = "" } = window.needPdpdata
      const { pageInfo: { contentType = "pdp" } = {} } = page
      page.category["subCategoryName"] = productSubCatergory
      page.pageInfo["pageName"] = `${siteName}:${
        contentType || "pdp"
      }:${productSubCatergory}:${skuID || pdpSkuUrl}`
      category["subCategory1"] = pageType + ":" + productSubCatergory
      category["subCategory2"] =
        pageType +
        ":" +
        productSubCatergory +
        ":" +
        productAnalyticsData.customerFacingSKU
      delete window.needPdpdata
    }
    pageInfo[assetType] = assetId
    pageInfo["resourceType"] = resourceType
    pageInfo["defaultImage"] = imagesData.length
      ? imagesData[0].assetId || imagesData[0].url
      : "n/a"
    page.category = category
    if (!isShowAnalyticsEventLoaded()) {
      page.user = getUserAnalyticsObject()
      page.productInfo = { ...productInfo }
      if (
        (!page.user.gId || page.user.gId === "n/a") &&
        (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")
      ) {
        page.pageInfo = pageInfo
        window.pageObj = page
        window.isShowAnalyticsEvent = true
      } else {
        setProductInfo(productAnalyticsData.stringProductInfo)
      }
    }
  }
}

export const addAnalyticsForConfiguratorButtonClick = (
  productInfo,
  buttonLabel
) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${PDP_DEATAIL}:${buttonLabel}`,
    eventMsg: "n/a",
    eventName: `${PDP}:${PDP_DEATAIL}:${buttonLabel}`,
    eventStatus: "n/a",
    eventType: NAVIGATION,
    internalLinkName: `${buttonLabel}`,
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${buttonLabel}`,
    internalLinkZoneName: `${PDP}:${PDP_DEATAIL}`,
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForConfiguratorModal = (
  productInfo,
  buttonLabel,
  modalStatus
) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${PDP_DEATAIL}:configurator modal ${modalStatus}`,
    eventMsg: "n/a",
    eventName: `${PDP}:${PDP_DEATAIL}:configurator modal ${modalStatus}`,
    eventStatus: "n/a",
    eventType: NAVIGATION,
    internalLinkName: `configurator modal ${modalStatus}`,
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${buttonLabel}`,
    internalLinkZoneName: `${PDP}:${buttonLabel}:configurator modal`,
    internalLinkURL: "n/a",
    modalName: "configurator modal",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForConfiguratorError = (productInfo, buttonLabel) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${PDP_DEATAIL}:configurator load error`,
    eventMsg: "Failed to initialize threekit player",
    eventName: `${PDP}:${PDP_DEATAIL}:configurator load error`,
    eventStatus: "n/a",
    eventType: NAVIGATION,
    internalLinkName: "configurator load error",
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${buttonLabel}`,
    internalLinkZoneName: `${PDP}:${buttonLabel}:configurator modal`,
    internalLinkURL: "n/a",
    modalName: "configurator modal",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}
